import Vue from 'vue'
import axios from 'axios'
import api from '../api'

export const state = {
  // Pagina curentă de facturi (newest-first). Paginarea + căutarea se fac pe
  // server (GET /invoices întoarce doar pagina, plus obiectul `pagination`).
  facturi: [],
  pagination: {
    page: 1,
    page_size: 10,
    total: 0,
    total_pages: 0
  },
  loading: false
}

export const actions = {
  async get_facturi ({ commit, state }, { search, page, page_size } = {}) {
    commit('SET_LOADING', true)
    try {
      const params = {
        search: (search && String(search).trim()) || undefined,
        page: page || 1,
        page_size: page_size || state.pagination.page_size || 10
      }
      const { data } = await axios.get(api.invoices, { params })
      commit('SET_FACTURI', data)
    } catch (e) {
      commit('SET_FACTURI', { invoices: [] })
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // DELETE /invoices/:id — șterge factura din ledger + rupe legătura cu comanda.
  async delete_factura ({ commit }, id) {
    await axios.delete(`${api.invoices}/${id}`)
    commit('REMOVE_FACTURA', id)
  },

  // PATCH /invoices/:id/paid { paid } — flag manual plătit/neplătit.
  async update_factura_paid ({ commit }, { id, paid }) {
    const { data } = await axios.patch(`${api.invoices}/${id}/paid`, { paid })
    commit('SET_FACTURA_PAID', { id, paid, doc: data })
  },

  // POST /invoice-smartbill-bulk — emite o factură din mai multe comenzi.
  // payload: { comanda_ids, client, draft? }. Răspuns: { ok, invoice_id, pdf_url, comanda_ids }.
  async emit_smartbill_bulk (_ctx, payload) {
    const { data } = await axios.post(api.invoice_smartbill_bulk, payload)
    return data
  },

  // Descarcă PDF-ul facturii ca blob. `pdf_url` din răspuns vine relativ și fără
  // prefix /api (ex: /invoice-smartbill/<id>), deci îl normalizăm; dacă lipsește,
  // folosim GET /invoice-smartbill/:comanda_id.
  async download_invoice_pdf (_ctx, { pdf_url, comanda_id, provider } = {}) {
    let url = pdf_url
    if (url) {
      if (!/^https?:\/\//i.test(url) && !url.startsWith('/api')) {
        url = '/api' + (url.startsWith('/') ? url : '/' + url)
      }
    } else if (comanda_id) {
      // Ledger-ul e partajat (SmartBill + Oblio); rutăm după furnizor. Fără
      // provider => SmartBill (comportamentul de dinainte, pentru facturi vechi).
      const base = provider === 'oblio' ? api.invoice_oblio : api.invoice_smartbill
      url = `${base}/${comanda_id}`
    } else {
      return null
    }
    return axios.get(url, { responseType: 'blob' })
  }
}

export const mutations = {
  SET_FACTURI (state, payload = {}) {
    // Acceptă atât forma nouă { invoices, pagination } cât și un array simplu.
    const invoices = Array.isArray(payload) ? payload : (payload.invoices || [])
    Vue.set(state, 'facturi', invoices)
    const p = (!Array.isArray(payload) && payload.pagination) || {}
    Vue.set(state, 'pagination', {
      page: +p.page || 1,
      page_size: +p.page_size || state.pagination.page_size || 10,
      total: +p.total || invoices.length,
      total_pages: +p.total_pages || 0
    })
  },

  SET_LOADING (state, value) {
    state.loading = value
  },

  REMOVE_FACTURA (state, id) {
    state.facturi = state.facturi.filter(f => f._id !== id)
    if (state.pagination.total > 0) state.pagination.total -= 1
  },

  SET_FACTURA_PAID (state, { id, paid, doc }) {
    const factura = state.facturi.find(f => f._id === id)
    if (!factura) return
    // Preferă documentul întors de server; fallback pe flag-ul trimis.
    factura.paid = doc && typeof doc.paid === 'boolean' ? doc.paid : paid
    if (doc && 'paid_at' in doc) factura.paid_at = doc.paid_at
  }
}
